import { defineMessages } from 'react-intl';

const scope = 'app.legacy.main.components.dashboard';

export default defineMessages({
    exportButton: {
        id: `${scope}.exportButton`,
        defaultMessage: 'Export to Excel',
    },
});